<template>
  <div class="page">
    <div class="logo" @click="changePage('/home')"></div>
    <div class="icon1"></div>
    <div class="iconCustomer" @click="changePage('/faq')"></div>
  </div>
</template>
<script setup lang="ts">
const changePage = function (pageName: string) {
  router.push(pageName)
}
</script>
<style scoped>
.logo {
  margin-top: 6.37rem;
  margin-left: 5.63rem;
  width: 8.19rem;
  height: 9rem;
  background-image: url(/src/assets/img/icon.png);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: left;
  z-index: 99;
  position: relative;
}

.icon1 {
  position: relative;
  margin-top: 6.06rem;
  margin-left: 5.94rem;
  width: 35.06rem;
  height: 45.5rem;
  background-image: url(/src/assets/img/news/icon1.png);
  background-size: contain;
  background-repeat: no-repeat;
  z-index: 1;
}

.iconCustomer {
  position: fixed;
  right: 2.38rem;
  bottom: 5.19rem;
  width: 23.44rem;
  height: 12.56rem;
  background-image: url(/src/assets/img/customer.png);
  background-size: contain;
  background-repeat: no-repeat;
  z-index: 1;
}
</style>
